import { render, staticRenderFns } from "./ContractDropdown.vue?vue&type=template&id=20828fe8&"
import script from "./ContractDropdown.vue?vue&type=script&lang=ts&"
export * from "./ContractDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./ContractDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem})
